<template>
  <div class="inline">
    <div class="inline" @click="openModal">
      <slot name="trigger">
        <button type="button" class="btn btn-default" :data-test="dataTest + '-trigger-button'">
          {{ triggerButtonTextToUse }}
        </button>
      </slot>
    </div>
    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <BaseModal
      v-cloak
      :is-open="isOpen"
      :modal-id="modalIdToUse"
      :header-text="headerText"
      :cancel-button-text="cancelButtonText"
      :confirm-button-text="actionButtonText"
      :saving-text="savingText"
      :save-state="modalSaveState"
      :data-test="dataTest"
      @positive-response="submit"
      @cancel="handleCancel"
      @negative-response="handleCancel"
    >
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <BaseHtmlForm
        ref="modalForm"
        data-ignore-unsaved
        :action="action"
        :method="method"
        class="text-left"
        :class="{ 'has-error': validationErrors.length > 0 }"
        accept-charset="UTF-8"
        append-user-and-account
      >
        <slot />
      </BaseHtmlForm>
    </BaseModal>
  </div>
</template>

<script>
import { ModalSaveState } from '@/utils/enum'

export default {
  props: {
    action: { type: String, required: true },
    headerText: { type: String, required: true },
    modalId: { type: String, default: '' },
    method: { type: String, default: 'POST' },
    cancelButtonText: { type: String, default: $t('Cancel') },
    actionButtonText: { type: String, default: $t('Save') },
    savingText: { type: String, default: $t('Saving...') },
    triggerButtonText: { type: String, default: '' },
    dataTest: { type: String, default: 'base-modal' },
  },

  data() {
    return {
      isOpen: false,
      validationErrors: [],
      modalSaveState: ModalSaveState.FRESH,
    }
  },
  computed: {
    triggerButtonTextToUse() {
      return this.triggerButtonText || this.headerText
    },
    modalIdToUse() {
      // Try to use something unique as the html id of the modal
      return this.modalId || this.action.replace(/\W/g, '')
    },
  },
  methods: {
    handleCancel() {
      this.isOpen = false
      this.modalSaveState = ModalSaveState.FRESH
    },
    openModal() {
      this.isOpen = true
    },
    submit() {
      // reset validation on submit
      this.validationErrors = []

      // check the form's validity if validation is enabled for any of the inputs
      const inputs = this.$refs.modalForm.$el.querySelectorAll('input, textarea')
      for (const i of inputs) {
        if (i.hasAttribute('data-validate') === true && i.dataset.validate === 'true') {
          if (
            i.hasAttribute('data-validation-min-length') !== null &&
            i.value.trim().length < parseInt(i.dataset.validationMinLength, 10)
          ) {
            this.validationErrors.push({
              el: i,
              error: `Input can not be less than ${i.dataset.validationMinLength} characters`,
            })
          }
        }
      }

      this.$emit('validation-result', this.validationErrors)

      if (this.validationErrors.length <= 0) {
        this.modalSaveState = ModalSaveState.SAVING
        this.$refs.modalForm.submit()
      }
    },
  },
}
</script>
